import PropTypes from "prop-types";
import React from "react";
import ProductCard from "web/react/components/product-card/product-card";
import Rail from "web/react/components/rail/rail";
import { ProductCardPropType } from "web/types/product-card";
import styles from "./product-rail.css";


function ProductRail({
    className,
    hiddenProductsCount,
    label,
    products,
    title,
    viewMoreUrl,
    railClassName,
    features,
}) {
    return (
        <Rail
            title={title}
            className={className}
            seeAllLink={viewMoreUrl}
            analyticsLabel={label}
            railClassName={railClassName}
            railsMoreButtonPlacement={features.uj_rails_more_button_placement}
            railMoreVariant={features.uj_rail_more_variant}
            showExtraRailItem={features.uj_show_extra_rail_item}
        >
            {products.map((product, index) => {
                return (
                    <ProductCard
                        className={styles.productCard}
                        key={product.id}
                        product={product}
                        hideOnDesktop={index < hiddenProductsCount ? true : false}
                    />
                );
            })}
        </Rail>
    );
}

ProductRail.propTypes = {
    className: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])),
    railClassName: PropTypes.string,
    hiddenProductsCount: PropTypes.number,
    label: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(ProductCardPropType).isRequired,
    title: PropTypes.string.isRequired,
    viewMoreUrl: PropTypes.string,
};

export default ProductRail;
